import React from 'react';
import {ReactComponent as LoaderComponent} from 'assets/images/animateLoader.svg';

const Loader = () => {
	return (
		<div>
			<LoaderComponent />
		</div>
	);
};

export default Loader;
